import { Component, OnInit, AfterViewInit, HostBinding, OnDestroy, NgModule, HostListener } from '@angular/core';
import { MensajeService } from './../servicios/mensaje.service';
import { AppComponent } from './../app.component';
import { Router } from '@angular/router';
import { trigger, transition, animate, style, query, stagger, state } from '@angular/animations';
import { Subscription } from 'rxjs';
import { NbSidebarService, NbMenuItem } from '@nebular/theme';
import { NbMenuService } from '@nebular/theme';
import { NbThemeService } from '@nebular/theme';
import { filter, map, take } from 'rxjs/operators';
import { PerfilesUsuarioService } from 'src/app/servicios/perfiles-usuario.service';
import { AveriasService } from '../servicios/averias.service';
import { MatDialog } from '@angular/material/dialog';
import { environment } from '../../environments/environment';
//import {SharedModule} from '../shared/shared.module';
import { FormsModule } from '@angular/forms'; // Para [(ngModel)]
import { DropdownModule } from 'primeng/dropdown'; // Para <p-dropdown>
import { NbIconModule } from '@nebular/theme'; // Para <nb-icon>
import { CommonModule } from '@angular/common';
//import { SpinnerComponent } from '../spinner/spinner.component';
import { NbCardModule } from '@nebular/theme';
import { MatCardModule } from '@angular/material/card';
import { NbMenuModule } from '@nebular/theme';
import { NbLayoutModule, NbSidebarModule } from '@nebular/theme';
import { NbContextMenuModule } from '@nebular/theme';
import { RouterModule } from '@angular/router';


@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.css'],
    animations: [
        trigger('pageAnimations', [
            transition(':enter', [
                query('.hero, form', [
                    style({ opacity: 0, transform: 'translateY(-100px)' }),
                    stagger(-30, [
                        animate('500ms cubic-bezier(0.35, 0, 0.25, 1)', style({ opacity: 1, transform: 'none' }))
                    ])
                ])
            ])
        ]),
        trigger('slideInOut', [
            transition(':enter', [
                style({ transform: 'translateY(-100%)' }),
                animate('800ms ease-in', style({ transform: 'translateY(0%)' }))
            ]),
            transition(':leave', [
                animate('200ms ease-in', style({ transform: 'translateY(-100%)' }))
            ])
        ]),
        trigger('slideInOut8', [
            transition(':enter', [
                style({ transform: 'translateY(-100%)' }),
                animate('1600ms ease-in', style({ transform: 'translateY(0%)' }))
            ]),
            transition(':leave', [
                animate('200ms ease-in', style({ transform: 'translateY(-100%)' }))
            ])
        ]),
        trigger('filterAnimation', [
            transition(':enter, * => 0, * => -1', []),
            transition(':increment', [
                query(':enter', [
                    style({ opacity: 0, width: '0px' }),
                    stagger(50, [
                        animate('300ms ease-out', style({ opacity: 1, width: '*' })),
                    ]),
                ], { optional: true })
            ]),
            transition(':decrement', [
                query(':leave', [
                    stagger(50, [
                        animate('300ms ease-out', style({ opacity: 0, width: '0px' })),
                    ]),
                ])
            ]),
        ]),
    ],
    standalone: true,
    imports: [ NbContextMenuModule, RouterModule, NbLayoutModule, NbSidebarModule , NbMenuModule,FormsModule,CommonModule,NbCardModule,NbIconModule,DropdownModule,MatCardModule],
})
export class HomeComponent implements OnInit, OnDestroy {
  title = 'Portal';
  reason = '';
  intervalId;
  // mensaje: string;
  // timer: Observable<any>;
  subscription: Subscription;
  innerWidth: number;
  orientacion: any;
  controlToggle = true;
  idCliente: number;
  userPictureOnly: boolean = false;
  userMenuImage: any = [];
  tag = 'menu-user-tag';
  dataStateSidebar: any;
  userMenuDespachantes = [{ title: 'Detalle' }];
  cliente: string = "";
  nombreApellido: string = "";
  operador: string = "";
  itemsUsuario = [{ title: 'Resetear Contraseña', icon: 'lock-outline', link: 'Perfil' }]
  v: string = "";
  constructor(private theme: NbThemeService,
    private router: Router, private app: AppComponent,
    private serviceMensaje: MensajeService, public usersRol: PerfilesUsuarioService,
    private sidebarService: NbSidebarService, private menuService: NbMenuService,
    private AveriasService: AveriasService, public dialog: MatDialog) {
    this.v = `${environment.version}`;
  }
  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.innerWidth = window.innerWidth;
    if (this.innerWidth < 800) {
      this.sidebarService.collapse();
    } else {
      this.sidebarService.compact();
    }
  }

  operarBotonUser(bag) {
  }
  menuOpciones = []

  ngOnInit() {
    this.idCliente = Number(localStorage.getItem('idCliente'));
    this.nombreApellido = localStorage.getItem('nombre') == 'null' ? '' : localStorage.getItem('nombre')
      + ' ' + localStorage.getItem('apellido') == 'null' ? '' : localStorage.getItem('apellido');
    this.cliente = localStorage.getItem('cliente') == 'null' ? '' : localStorage.getItem('cliente');
    this.operador = localStorage.getItem('operador') == 'null' ? '' : localStorage.getItem('operador');
    this.gestionarMenu();
    this.menuService.onItemClick()
      .pipe(
        filter(({ tag }) => tag === 'menu-user-tag'),
      )
      .subscribe((item: any) => {
        this.takeActionMenuClicked(item.item.data.id)
      });
    this.menuService.onItemClick()
      .pipe(
        filter(({ tag }) => tag === 'menu'),
        map(({ item: { title } }) => title),
      )
      .subscribe(title => this.takeActionMenuClicked(title));

    this.setSizeDisplay();

  }
  pushMenuManuales() {
    let idTipoOperador = JSON.parse(localStorage.getItem('idTipoOperador'))
    let tipoPerfil = this.usersRol.ADMINOPERADOR ? 'Admin' : (localStorage.getItem('perfil') || '');
    let tipoOperador = ''
    let appManual = ''
    let webManual = ''
    let children = [];

    if (idTipoOperador) {
      switch (idTipoOperador) {
        case 1: {
          tipoOperador = 'Transporte'
          break
        }
        case 2: {
          tipoOperador = 'Naviera'
          break
        }
        case 3: {
          tipoOperador = 'Playa'
          break
        }
        case 4: {
          tipoOperador = 'Concesionario'
          break
        }
        case 5: {
          tipoOperador = 'Planta'
          break
        }
        case 6: {
          tipoOperador = 'Puerto'
          break
        }
        default:
          break
      }
      webManual = `https://infinitstor.blob.core.windows.net/infinit/Manual%20de%20uso%20VCA%20Desktop%20-%20Usuarios%20v1.3%20${tipoPerfil}%20${tipoOperador}.pdf`

      if (idTipoOperador === 2 || idTipoOperador === 6) {
        appManual = 'https://infinitstor.blob.core.windows.net/infinit/Manual%20de%20uso%20VCA%20App%20-%20Usuarios%20v3.6%20Puerto%20y%20Naviera.pdf'
      } else {
        appManual = 'https://infinitstor.blob.core.windows.net/infinit/Manual%20de%20uso%20VCA%20App%20-%20Usuarios%20v3.6%20Concesionario,%20Transporte,%20Playa%20y%20Planta.pdf'
      }

    } else {
      if (tipoPerfil.includes('Nivel 2')) tipoPerfil = 'Nivel%202'
      else if (tipoPerfil.includes('Nivel 3')) tipoPerfil = 'Nivel%203'
      else tipoPerfil = 'Nivel%201'

      // if (tipoPerfil.includes('Soporte VCA') || tipoPerfil.includes('Nivel 1')) {
      //   webManual = 'https://infinitstor.blob.core.windows.net/infinit/Manual_uso_vca_web.pdf'
      //   appManual = 'https://infinitstor.blob.core.windows.net/infinit/Manual_uso_vca_app.pdf'
      // } else {
      // }
      webManual = `https://infinitstor.blob.core.windows.net/infinit/Manual%20de%20uso%20VCA%20Desktop%20-%20Usuarios%20v1.3%20Usuario%20${tipoPerfil}.pdf`
      appManual = 'https://infinitstor.blob.core.windows.net/infinit/Manual_uso_vca_app.pdf'
    }

    children = [
      {
        title: 'Manual de Usuario Web',
        icon: 'external-link-outline',
        url: `${webManual}`,
        target: '_blank',
      },
      {
        title: 'Manual de Usuario App',
        icon: 'external-link-outline',
        url: `${appManual}`,
        target: '_blank',
      }
    ]
    return children;
  }
  pushMenuMaestros() {
    var children = [];
    // Cambiar estos en el Admin 1
    if (this.usersRol.GESTIONAR_PARAMETROS_SISTEMA || this.usersRol.CONSULTAR_PARAMETROS_SISTEMA) {
      children = [
        {
          title: 'Área',
          icon: '',
          link: 'Area',
        },
        {
          title: 'Grupo Tipo',
          icon: '',
          link: 'GrupoTipo',
        },
        {
          title: 'Tipo',
          icon: '',
          link: 'Tipo'
        },
        {
          title: 'Severidad',
          icon: '',
          link: 'Severidad'
        },
        {
          title: 'Componente',
          icon: '',
          link: 'Componente'
        },
        {
          title: 'Área Componente',
          icon: '',
          link: 'AreaComponente'
        }
      ]
    }
    //Esto estaba comentado por mati porque funciona mal
    if (this.usersRol.GESTIONAR_MODELOS || this.usersRol.CONSULTAR_MODELOS) {
      children.push(
        {
          title: 'Modelos',
          icon: '',
          link: 'Modelos'
        }
      )
    }
    if (this.usersRol.GESTIONAR_BUQUES || this.usersRol.CONSULTAR_BUQUES) {
      children.push(
        {
          title: 'Buques',
          icon: '',
          link: 'Buques'
        }
      )
    }
    if (this.usersRol.GESTIONAR_OPERADORES || this.usersRol.CONSULTAR_OPERADORES) {
      if (this.usersRol.GESTIONAR_PARAMETROS_SISTEMA) {
        children.push(
          {
            title: 'Operadores',
            icon: '',
            link: 'Operadores'
          },
          {
            title: 'Operadores a Cliente',
            icon: '',
            link: 'ClientesOperadores'
          }
        )
      } else {
        children.push(
          {
            title: 'Operadores a Cliente',
            icon: '',
            link: 'ClientesOperadores'
          }
        )
      }
    }
    return children
  }
  pushReportes() {
    var children = []
    if (this.usersRol.REPORTES_BI) {
      children.push({
        title: 'Power BI',
        icon: '',
        link: 'PowerBI'
      })
    }
    if (this.usersRol.REPORTES_INTERNOS) {
      children.push({
        title: 'Reportes Internos',
        icon: '',
        link: 'ReportesInternos'
      })
    }
    return children
  }
  gestionarMenu() {
    this.menuOpciones = [];
    //pusheamos consultas y discrepancias
    if (this.usersRol.CONSULTAR_AVERIAS != false || this.usersRol.GESTIONAR_DISCREPANCIAS) {
      this.menuOpciones.push(
        {
          title: 'Inspecciones',
          icon: 'eye-outline',
          link: 'ConsultaInspecciones',
        })
    }
    //pusheamos masestros
    if (this.usersRol.GESTIONAR_OPERADORES || this.usersRol.CONSULTAR_OPERADORES ||
      this.usersRol.GESTIONAR_BUQUES || this.usersRol.CONSULTAR_BUQUES ||
      this.usersRol.GESTIONAR_MODELOS || this.usersRol.CONSULTAR_MODELOS ||
      this.usersRol.GESTIONAR_PARAMETROS_SISTEMA || this.usersRol.CONSULTAR_PARAMETROS_SISTEMA)
      this.menuOpciones.push({
        title: 'Maestro',
        icon: 'options-2-outline',
        link: '',
        children: this.pushMenuMaestros()
      })
    //pusheamos Nuevo Modulo VINS - JALBANO
    if (this.usersRol.ALTA_VISITA || this.usersRol.MODIFICAR_VISITA || this.usersRol.ELIMINAR_VISITA || this.usersRol.CONSULTAR_VISITA) {
      this.menuOpciones.push({
        title: 'Asociar VINS a buques',
        icon: 'swap-outline',
        link: 'VinsBuques'
      })
    }
    //pusheamos reparaciones
    if (this.usersRol.GESTIONAR_REPARACIONES_DEBITOS || this.usersRol.GESTIONAR_REPARACIONES_SEGUROS) {
      this.menuOpciones.push({
        title: 'Gestión de recuperos',
        icon: 'scissors-outline',
        link: 'Reparaciones',
      })
    }
    //pusheamos criterios similitud
    if (this.usersRol.GESTIONAR_CRITERIOS_SIMILITUD) {
      this.menuOpciones.push({
        title: 'Criterios de Similitud',
        icon: 'done-all-outline',
        link: 'CriteriosDeSimilitud'
      })
    }
    //pusheamos Gestion de Usuarios para clientes
    if (this.usersRol.GESTIONAR_USUARIOS) {
      this.menuOpciones.push({
        title: 'Gestion de Usuarios Cliente',
        icon: 'people-outline',
        link: 'GestionUsuarios'
      })
    }
    //pusheamos Gestion de Usuarios para operadores
    if (this.usersRol.ADMINOPERADOR) {
      this.menuOpciones.push({
        title: 'Gestion de Usuarios Operadores',
        icon: 'people-outline',
        link: 'GestionUsuariosOperador'
      })
    }
    //pusheamos Consulta de Usuarios para operadores
    if (this.usersRol.CONSULTA_USUARIO_OPERADOR) {
      this.menuOpciones.push({
        title: 'Consulta de Usuarios Operadores',
        icon: 'people-outline',
        link: 'ConsultarUsuariosOperador'
      })
    }
    //pusheamos manuales de Operadores
    if (this.usersRol.GESTIONAR_ARCHIVOS_USUARIOS || this.usersRol.CONSULTAR_ARCHIVOS_USUARIOS) {
      this.menuOpciones.push({
        title: 'Manuales de Operadores',
        icon: 'file-text-outline',
        link: 'ManualesOperadores',
      })
    }
    //pusheamos reportes
    if (this.usersRol.REPORTES_BI) {
      this.menuOpciones.push({
        title: 'Reportes',
        icon: 'pie-chart-outline',
        link: '',
        children: this.pushReportes()
      })
    }
    //pusheamos manuales de Usuarios
    this.menuOpciones.push({
      title: 'Manuales de Usuario',
      icon: 'book-outline',
      link: '',
      children: this.pushMenuManuales()
    })
  }
  cerrarSession() {
    localStorage.removeItem("token");
    localStorage.removeItem("cliente");
    localStorage.removeItem("idCliente");
    localStorage.removeItem('nombre');
    localStorage.removeItem('apellido');
    localStorage.removeItem('operador');
    localStorage.removeItem('idOperador');
    localStorage.removeItem('username');
    localStorage.removeItem('pass');
    localStorage.removeItem('timeToken');
    localStorage.removeItem('tk_vca');
    localStorage.removeItem('esCliente');
    localStorage.removeItem('perfil');
    this.app.ingreso = false;
    this.router.navigate(['']);//#
  }
  takeActionMenuClicked(titulo) {
    this.setSizeDisplay();
    this.toggleCompact();
  }
  takeActionUserMenuClicked(titulo) {
    switch (titulo) {
      case 'Dashboard': {
        //statements; 
        break;
      }
    }
  }
  setSizeDisplay() {
    this.innerWidth = window.innerWidth;
    if (this.innerWidth < 800) {
      this.sidebarService.collapse();
    } else {
      this.sidebarService.compact();
    }
  }
  toggle() {
    this.sidebarService.toggle(false, 'left');
  }
  toggleCompact() {
    if (this.innerWidth < 800) {
      this.sidebarService.toggle(false, 'menu');
    } else {
      this.sidebarService.toggle(true, 'menu');
    }
  }
  collapseAll() {
    this.menuService.collapseAll('menu');
  }
  navigateHome() {
    this.menuService.navigateHome('menu');
  }
  ngAfterViewInit() {
    setTimeout(() => {
      this.toggleCompact();
      this.router.navigate(['/']);
    }, 0);

  }


  currentState = 'initial';
  changeState() {
    this.currentState = this.currentState === 'initial' ? 'final' : 'initial';
  }

  onValueChanged = (event) => {
    try {
      if (event.srcElement.name === 'toFixed') {
        let toFixed = +event.srcElement.value;
      }
    } catch (e) {
      console.error(e)
    }
  }

  cambioEstadoToggleLogic(event) {
    this.sidebarService.toggle(true, 'menu');
  }

  clickPrincipal(event) {
    this.setSizeDisplay();
  }

  ngOnDestroy() {
    clearInterval(this.intervalId);
    this.serviceMensaje.limpiarMensaje();
  }

  // traerDatosMaestros(){
  //   this.AveriasService.getMaestros(this.idCliente).subscribe(data => {

  //   })
  // }
}